export default __webpack_public_path__ + "static/media/bb13.4daa9083.webp";